import {
    FavoriteBorder,
    FavoriteRounded,
    ShareRounded,
} from '@mui/icons-material';
import { Badge, Chip, Grid, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useLoadDevotionInfoQuery } from '../../api/apiSlice';
import { useToggleLikeMutation } from '../../api/feedSlice';
import Screen from '../../components/fragments/Screen';
import AudioPlayer from '../../components/utilities/AudioPlayer';
import { handleGuestFeedShare } from '../../utils/sharePost';

export default function DevotionRouteScreen() {
    const { id } = useParams();
    const { state } = useLocation();

    const [toggleLike, { isLoading }] = useToggleLikeMutation();
    const { data, isFetching, refetch } = useLoadDevotionInfoQuery(id, {
        refetchOnMountOrArgChange: true,
    });

    const { title, writer } = data?.data || state || {};
    const { audio, interactions, devotion, church } = data?.data || {};
    const { liked, likes } = interactions || {};

    const onLikeFeed = async () => {
        const { data: likeData } = await toggleLike({ id, type: 'devotions' });
        if (likeData) refetch();
    };

    return (
        <>
            <Screen
                loading={isFetching || isLoading}
                title="Devotion"
                controls={
                    <div>
                        <IconButton
                            color="primary"
                            disabled={isLoading}
                            sx={{ color: 'secondary.main', mr: 1 }}
                            onClick={onLikeFeed}
                        >
                            <Badge badgeContent={likes} color="secondary">
                                {liked ? (
                                    <FavoriteRounded />
                                ) : (
                                    <FavoriteBorder />
                                )}
                            </Badge>
                        </IconButton>
                        <IconButton
                            color="primary"
                            onClick={() => {
                                handleGuestFeedShare(
                                    { title, id, audio, church },
                                    'devotions'
                                );
                            }}
                        >
                            <ShareRounded />
                        </IconButton>
                    </div>
                }
            >
                <Grid item xs={12} sx={{ mb: 16 }}>
                    <Chip
                        variant="outlined"
                        color="primary"
                        label="sermon"
                        size="small"
                    />
                    <Typography className="fw-bold mt-3">{title}</Typography>
                    <Typography color="text.secondary" className="fw-bold mb-2">
                        {writer}
                    </Typography>
                    <Typography
                        className="text-justify"
                        dangerouslySetInnerHTML={{ __html: devotion }}
                    ></Typography>
                </Grid>
            </Screen>
            <div
                className="w-100"
                style={{ position: 'fixed', bottom: 0, padding: 16 }}
            >
                <AudioPlayer audio={audio} />
            </div>
        </>
    );
}
